import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoginComponent } from './components/login/login.component';
import { CambiarPasswordComponent } from './components/usuarios/cambiar-password/cambiar-password.component';
import { MiPerfilComponent } from './components/usuarios/mi-perfil/mi-perfil.component';
import { UsuarioCardComponent } from './components/usuarios/usuario-card/usuario-card.component';
import { UsuarioFormComponent } from './components/usuarios/usuario-form/usuario-form.component';
import { BuscarEstudianteComponent } from './components/buscar-estudiante/buscar-estudiante.component';
import { EstudianteDetailComponent } from './components/estudiante-detail/estudiante-detail.component';
import { ExamenesListComponent } from './components/examenes-list/examenes-list.component';
import { EstudiantesListComponent } from './components/estudiantes-list/estudiantes-list.component';
import { EstudianteCardComponent } from './components/estudiante-card/estudiante-card.component';
import { CentrosEntrenamientoComponent } from './components/centros-entrenamiento/centros-entrenamiento.component';
import { EstudianteService } from './services/estudiante.service';
import { ExamenService } from './services/examen.service';
import { SharedService } from './services/shared.service';
import { CentroEntrenamientoService } from './services/centro-entrenamiento.service';
import { DatePipe } from '@angular/common';
import { InstructoresComponent } from './components/instructores/instructores.component';
import { PopupComponent } from './components/popup/popup.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { CalculadoraPromediosComponent } from './components/calculadora-promedios/calculadora-promedios.component';
import { WindowService } from './services/window.service';
import { GeografiaService } from './services/geografia.service';
import { AutocompleteInputComponent } from './components/utils/autocomplete-input/autocomplete-input.component';
import { CinturonGraphicsComponent } from './components/utils/cinturon-graphics/cinturon-graphics.component';
import { ControlExamenComponent } from './components/control-examen/control-examen.component';
import { TablaControlComponent } from './components/control-examen/tabla-control/tabla-control.component';
import { RegistroRecepcionComponent } from './components/control-examen/registro-recepcion/registro-recepcion.component';
import { ControlExamenService } from './services/control-examen.service';
import { FindMaderaPipe } from './components/control-examen/find-madera.pipe';
import { CurrencyFormatPipe } from './components/control-examen/currency-format.pipe';
import { ItfDatabaseComponent } from './components/itf-database/itf-database.component';
import { ItfDatabaseDetailComponent } from './components/itf-database/itf-database-detail/itf-database-detail.component';
import { ItfPaymentModalComponent } from './components/itf-database/itf-payment-modal/itf-payment-modal.component'; // ✅ CORRECT import name
import { ItfDatabaseService } from './services/itf-database.service';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { UserService } from './services/user.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MiPerfilComponent,
    CambiarPasswordComponent,
    UsuariosComponent,
    UsuarioCardComponent,
    UsuarioFormComponent,
    BuscarEstudianteComponent,
    EstudianteDetailComponent,
    ExamenesListComponent,
    EstudiantesListComponent,
    EstudianteCardComponent,
    CentrosEntrenamientoComponent,
    InstructoresComponent,
    PopupComponent,
    CalculadoraPromediosComponent,
    AutocompleteInputComponent,
    CinturonGraphicsComponent,
    ControlExamenComponent,
    TablaControlComponent,
    RegistroRecepcionComponent,
    FindMaderaPipe,
    CurrencyFormatPipe,
    ItfDatabaseComponent,
    ItfDatabaseDetailComponent,
    ItfPaymentModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    UserService,
    EstudianteService,
    ExamenService,
    ItfDatabaseService,
    SharedService,
    CentroEntrenamientoService,
    GeografiaService,
    DatePipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    WindowService,
    ControlExamenService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }